import { useUpdateZipCode } from '@customink/project-service-react-components';
import { SYNC_STRATEGIES } from '@customink/project-service-types';
import { useCallback } from 'react';

export const useUpdateZipCodeSync = () => {
  const [trigger, result] = useUpdateZipCode();
  const curriedTrigger = useCallback(
    (zipCode?: string) =>
      trigger({ zipCode, syncStrategy: SYNC_STRATEGIES.CORE_ORDER }),
    [trigger],
  );
  return [curriedTrigger, result] as const;
};
